import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseCreateCompanyBranchAdditionalDocumentProps {
  branchId?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useCreateCompanyBranchAdditionalDocument = ({
  branchId,
  onSuccess,
  onError,
}: UseCreateCompanyBranchAdditionalDocumentProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createCompanyBranchAdditionalDocument'],
    mutationFn: (blob_id: string) => {
      const payload = {
        company_branch: {
          additional_documents_attachments_attributes: [
            {
              blob_id,
            },
          ],
        },
      }

      return privateAxios.put(`/client/company_branches/${branchId}/update_additional_documents`, payload)
    },
    onSuccess,
    onError,
  })
}
